<template>
  <div>
    <div class="landing-page pa-4">
      <div class="header-container ma-4">
        <div :class="{'header-content': $vuetify.breakpoint.width > 1280}">
          <div
            class="logo-and-menu"
            :class="{
              'display-flex justify-center align-center':
                $vuetify.breakpoint.width <= 1280,
            }"
          >
            <div class="logo-container" @click="tab = null">
              <router-link to="/" class="logo-link">
                <img
                  src="/static/images/landing-page/ys_logo_primary-black.svg"
                  aspect-ratio="1"
                  height="44"
                  width="144"
                />
              </router-link>
            </div>
            <div
              v-if="$vuetify.breakpoint.width > 1280"
              class="links-container white--text font-space-grotesk font-weight-700 text-18"
            >
              <span
                v-for="(item, index) in tabList"
                :key="index"
                class="menu-item cursor-pointer"
                :class="{ 'active-menu': tab == item.value }"
                @click="tab = item.value"
              >
                {{ item.text }}
              </span>
              <span
                class="menu-item cursor-pointer"
                @click="navigateTo('/login')"
              >
                Signin
              </span>
            </div>
          </div>
        </div>
      </div>

      <div :class="{'main-content': $vuetify.breakpoint.width > 1280}">
        <v-layout
          v-if="!tab"
          align-center
          justify-space-around
          row
          gap-8
          main-content-wrapper
        >
          <div class="blurb-container">
            <div
              :class="{'text-container': $vuetify.breakpoint.width > 1280}"
              class="white--text font-space-grotesk font-weight-500"
            >
              <span
                :class="
                  $vuetify.breakpoint.width <= 1280
                    ? 'text-32 text-center display-flex'
                    : 'text-50'
                "
              >
                Music Streaming
                <br />
                Evolved
              </span>
              <div
                v-if="$vuetify.breakpoint.width > 1280"
                class="app-icons-container"
              >
                <v-layout align-center row mt-4 pt-4>
                  <div class="app-icon-container">
                    <img
                      src="/static/images/landing-page/apple-store.svg"
                      aspect-ratio="1"
                      height="80"
                      width="220"
                      @click="openQrCode(qrCodeTypeList.IOS)"
                      class="cursor-pointer"
                    />
                  </div>
                  <div class="app-icon-container">
                    <img
                      src="/static/images/landing-page/google-play.svg"
                      aspect-ratio="1"
                      height="80"
                      width="220"
                      @click="openQrCode(qrCodeTypeList.ANDROID)"
                      class="cursor-pointer"
                    />
                  </div>
                </v-layout>
              </div>
            </div>
          </div>
          <div class="image-container">
            <img
              src="/static/images/landing-page/ys-landing-ios.svg"
              aspect-ratio="1"
              height="677"
            />
          </div>
        </v-layout>

        <UpgradePlan
          v-if="tab == 'go_premium'"
          :category-plan="categoryPlan"
          class="py-5"
        />
        <RevenueCalculator
          v-if="tab == 'revenue_calculator'"
          class="py-5 w-100"
        />
      </div>
    </div>

    <div
      v-if="$vuetify.breakpoint.width <= 1280"
      :class="{
        'bg-white sp-text': tab == null,
      }"
    >
      <div
        v-if="tab == null"
        :class="[
          'display-flex justify-space-between align-center btn-wrapper',
          { 'scrolled': isScrolled }
        ]"
      >
        <button class="btn-try-calculator" @click="goToCalculator">
          Estimator
        </button>
        <button class="btn-sign-up" @click="redirectToAppStore">
          Sign up
        </button>
      </div>
      <!-- <div v-if="tab == null" class="information">
        YouSound is a music streaming platform for independent artists, offering
        fair compensation.
        <br />
        <br />
        Transparent payments are paid directly from subscribers to artists,
        within days.
        <br />
        <br />
        Free for creators, no distributor needed.
      </div> -->
    </div>

    <FooterLandingPage v-if="$vuetify.breakpoint.width > 1280" />
    <QrCode ref="qrCode" />
  </div>
</template>

<script>
import UpgradePlan from "./components/UpgradePlan.vue";
import RevenueCalculator from "./components/RevenueCalculator.vue";
import FooterLandingPage from "./components/FooterLandingPage.vue";
import QrCode from "@/components/base/qr_code";
import { QrCodeTypeList } from "@/helper";

export default {
  components: {
    UpgradePlan,
    RevenueCalculator,
    FooterLandingPage,
    QrCode,
  },
  data() {
    return {
      openQrCode(type) {
        return this.$refs.qrCode.openQrCode(type);
      },
      qrCodeTypeList: QrCodeTypeList,
      categoryPlan: "creator",
      tab: null,
      tabList: [
        // { text: "Go Premium", value: "go_premium" },
        { text: "Estimator", value: "revenue_calculator" },
      ],
      isScrolled: false,
    };
  },
  methods: {
    navigateTo(path) {
      this.tab = null;
      this.$router.push({ path });
    },
    redirectToAppStore() {
      const userAgent = navigator.userAgent || navigator.vendor || window.opera;

      if (/android/i.test(userAgent)) {
        window.location.href =
          "https://play.google.com/store/apps/details?id=com.example.android"; // Replace with your Android app link
      } else if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
        window.location.href =
          "https://apps.apple.com/us/app/yousound/id1452078262"; // Replace with your iOS app link
      } else {
        window.location.href = "/signup"; // Fallback for web browsers
      }
    },
    handleScroll() {
      this.isScrolled = window.scrollY > 0;
    },
    scrollToTop() {
      window.scrollTo({ top: 0, behavior: "smooth" });
    },
    goToCalculator() {
      this.tab = "revenue_calculator";
      this.$nextTick(() => {
        this.scrollToTop();
      });
    },
  },
  mounted() {
    window.addEventListener("scroll", this.handleScroll);
  },
  beforeDestroy() {
    window.removeEventListener("scroll", this.handleScroll);
  },
  watch: {
    $route() {
      this.tab = null;
    },
  },
};
</script>

<style lang="scss" scoped>
.landing-page {
  background-position: center top;
  background-repeat: no-repeat;
  background-size: cover;
  background-image: url("/static/images/bg-landing-page.svg"); /* Default for desktop */
  width: 100%;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;
  background-color: black;
  opacity: 0;
  animation: fadeInBackground 1.5s ease-in-out forwards;
}

@keyframes fadeInBackground {
  0% {
      opacity: 0;
  }
  100% {
      opacity: 1;
  }
}

.header-container {
  width: 100%;
  display: flex;
  justify-content: center;
  padding: 0 2.5rem;
}

.header-content {
  max-width: 1200px;
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.logo-and-menu {
  display: flex;
  align-items: center;
}

.logo-container {
  display: flex;
  justify-content: flex-start;
}

.links-container {
  display: flex;
  justify-content: flex-start;
  margin-left: 2.5rem;
}

.menu-item {
  margin-right: 2.25rem;
  margin-left: 0.625rem;
  position: relative;
  font-weight: 600;
}

.menu-item::after {
  content: "";
  display: block;
  width: 0;
  height: 2px;
  background: #fff;
  transition: width 0.3s;
  position: absolute;
  bottom: -4px;
  left: 0;
}

.menu-item.active-menu::after {
  width: 100%;
}

.main-content {
  max-width: 1200px;
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.blurb-container {
  max-width: 600px;
  margin: 0; /* Adjust this value as needed */
}

.text-container {
  margin-top: -3.125rem;
  margin-left: -7rem;
  margin-right: 4.875rem;
}

.app-icons-container {
  margin-top: 3.125rem;
  margin-bottom: 1.25rem; /* Add margin-bottom to push down app icons */
}

.image-container {
  max-width: 500px;
  margin-bottom: 50px;
  margin-right: 0; /* Default margin for mobile */

  @media screen and (min-width: 1281px) {
    margin-right: -4.375rem; /* Margin for desktop */
  }
}

.app-icon-container {
  margin-right: 1.8rem;
}

.app-icon-container:last-child {
  margin-right: 0;
}

.footer-landing-page {
  background-color: #eceff2;
  padding: 3.125rem 9.375rem 2.5rem;
}

.input-email {
  padding: 0.25rem;
  margin-left: 1.25rem;
  border-radius: 0.625rem;
  height: 3.5625rem;
  input {
    outline: none !important;
  }
}

.styled-divider {
  border: 0;
  height: 1px;
  background-color: #d9d9d9;
  margin-bottom: 0.625rem; /* Adjust this value to match the "mt-5" margin */
}

.input-email input::placeholder {
  outline: none !important;
  font-family: Poppins !important;
  font-size: 1rem;
  color: #454545;
  font-weight: 500;
}

.logo-link {
  display: inline-block;
}

.information {
  font-family: Outfit;
  font-weight: 700;
  font-size: 2.5rem; /* Default font size for larger screens */
  line-height: 3rem;
  text-align: center;
  margin: 0 auto;
  padding: 5% 10%; /* Padding in percentage */

  @media (max-width: 768px) {
    font-size: 2rem; /* Adjust font size for medium screens */
    padding: 5% 8%;
  }

  @media (max-width: 480px) {
    margin-top: 50px;
    font-size: 2.1rem; /* Adjust font size for small screens */
    padding: 5% 5%;
  }

  @media (max-width: 375px) {
    font-size: 1.9rem; /* Adjust font size for extra small screens */
    padding: 5% 3%;
  }
}

.btn-wrapper {
  position: fixed;
  bottom: 0;
  background: #000;
  z-index: 1;
  padding: 1.25rem 0.75rem;
  gap: 0.25rem;
  left: 0;
  width: 100%;
  display: flex;
  justify-content: center; /* Center the buttons */
  transition: background-color 0.3s;
}

.btn-wrapper.scrolled {
  background-color: #fff; /* Change background to white when scrolled */
}

.btn-try-calculator,
.btn-sign-up {
  font-family: Outfit;
  font-size: 1.25rem; /* 20px */
  font-weight: 600;
  text-align: center;
  height: 3.125rem; /* 50px */
  padding: 0 1.5rem; /* 24px */
  border-radius: 3.5rem; /* 56px */
  min-width: 10.5rem; /* 168px */
  display: flex;
  align-items: center;
  justify-content: center;
  letter-spacing: 0;
  margin: 0 0.625rem; /* 10px, Add margin between the buttons */
  transition: color 0.3s, background-color 0.3s;
}

.btn-try-calculator {
  color: rgba(255, 255, 255, 0.8);
}

.btn-sign-up {
  background: rgba(39, 126, 255, 1);
  color: #fff;
}

.btn-wrapper.scrolled .btn-try-calculator {
  color: rgba(0, 0, 0, 0.8); /* Change text color to black when scrolled */
  background-color: #f9f9f9; /* Change background color to #f9f9f9 when scrolled */
}

.btn-wrapper.scrolled .btn-sign-up {
  background: rgba(39, 126, 255, 1);
  color: #fff; /* Ensure text color remains white */
}

.text-32 {
  font-size: 2.5rem; /* 40px */
  line-height: 2.5rem; /* 40px */
  font-weight: 600;
  margin-top: 3.125rem; /* 50px */
  margin-bottom: 4.25rem; /* 20px */
}

.sp-text {
  margin-top: -12.5rem; /* 200px */
  padding: 9.5rem 1.25rem;
}

@media screen and (max-width: 1024px) and (min-width: 768px) {
  .landing-page {
    background-color: #000; /* Apply black background for tablet */
    background-image: none; /* Remove background image for tablet */
    min-height: 1400px;
  }
}

@media screen and (max-width: 1280px) {
  .landing-page {
    background-color: #000; /* Apply black background for mobile */
    background-image: none; /* Remove background image for mobile */
  }

  .main-content-wrapper {
    flex-direction: column;
  }

  .btn-wrapper {
    justify-content: center; /* Center the buttons */
  }

  .btn-try-calculator,
  .btn-sign-up {
    width: 12.5rem; /* 200px */
  }
}
</style>




// WEBPACK FOOTER //
// index.vue?76e38181